// FontAwesome Brands setup using the installed packages
import Vue from 'vue'
import { config, library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome-svg-core/styles.css'
import '../../../shared/styles/fontawesome-vuetify.css'
import {
	faShopify
} from '@fortawesome/free-brands-svg-icons'

// Prevent FontAwesome from injecting a <style> tag at runtime (CSP compliance).
// Core styles are imported statically from @fortawesome/fontawesome-svg-core/styles.css above.
config.autoAddCss = false

// Add icons to the library
library.add(
	faShopify
)

// Register the FontAwesome component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)
